import axios from 'axios';
import { useEffect, useRef, useState } from 'react';
import { useAlert } from 'react-alert';
import { Button, Modal, Spinner } from 'react-bootstrap';
import { BsCheck } from 'react-icons/bs';
import { FaUserCheck } from 'react-icons/fa6';
import { IoMdClose } from 'react-icons/io';
import { IoCloudUpload } from 'react-icons/io5';
import { useLocation, useNavigate } from 'react-router-dom';
import swal from 'sweetalert';
import { BASE_URL } from '../../insightConfig/insightConfig';
import '../CurrentPage/CategoryButton.css';
import "../CurrentPage/Current.css";
import '../Settings/Setting.js';
import HomePageText from './child_components/HomePageText.js';
import IDPDownloads from './child_components/IDPDownloads.js';
import logo1 from "./insight_icon.jpeg";
import IGPClasses from './child_components/IGPClasses.js';


function InterviewGuidance() {
    const authtoken = localStorage.getItem('authtoken');
    const [modalBox, setModalBox] = useState(false);
    const [sessionDetailsModal, setSessionDetailsModal] = useState(false);

    const [activeButton, setActiveButton] = useState('homepage');
    const [categories, setCategories] = useState([{ Category: "Book Your Slot" }, { Category: "IGP Classes" }, { Category: "Downloads" }]);
    const [fileUploading1, setFileUploading1] = useState(false);
    const [fileUploading2, setFileUploading2] = useState(false);
    const initialSignupData = { UPSCRollNo: "", InterviewDate: "", Daf1: "", Daf2: "" }
    const now = new Date();

    const initialSessionDetails = {
        InterviewDate: now.toISOString().slice(0, 10), // "YYYY-MM-DD"
        InterviewTime: now.toTimeString().slice(0, 5), // "HH:MM"
        Location: ""
    };

    const [sessionDetails, setSessionDetails] = useState(initialSessionDetails);
    const [signupData, setSignupData] = useState(initialSignupData);
    const [isIGPRegistered, setIsIGPRegistered] = useState(false);
    const [isNextSlotBookingEnabled, setIsNextSlotBookingEnabled] = useState(false);
    const [userData, setUserData] = useState({});
    const alert = useAlert();
    const navigate = useNavigate();

    const fileRef1 = useRef(null);
    const fileRef2 = useRef(null);

    useEffect(() => {
        if (!authtoken) return;
        axios.get(`${BASE_URL}/studentdashboard`)
            .then(response => {
                setUserData(response.data.data[0]);
            })
            .catch(error => {
                console.error("Error fetching data:", error);
            });

    }, [authtoken]);

    // useEffect(() => {
    //     if (!location.state.paymentdone) return;
    //     setSessionDetailsModal(true);
    // }, [location.state.paymentdone]);









    useEffect(() => {
        if (authtoken) {
            axios.get(`${BASE_URL}/igp/isIGPRegistered`)
                .then(response => {
                    console.log(response.data);
                    if (response.data.isIGPRegistered) {
                        setIsIGPRegistered(true);
                    } else {
                        setIsIGPRegistered(false);
                    }
                })
                .catch(error => {
                    console.error('Error during registration:', error);
                    // Handle error (e.g., show an error message)
                })

            axios.get(`${BASE_URL}/igp/isNextSlotBookingEnabled`).then(response => {
                console.log(response);
                if (response.data.isNextSlotBookingEnabled) {
                    setIsNextSlotBookingEnabled(true);
                } else {
                    setIsNextSlotBookingEnabled(false);
                }
            }).catch(error => {
                console.error('Error: ', error);
                // Handle error (e.g., show an error message)
            })
        }


    }, [authtoken]);

    const handleClick = (Category) => {
        if (Category == 'Book Your Slot') {
            if (!authtoken) {
                alert.error("Please login first");
                setTimeout(() => {
                    navigate('/login');
                }, 1000);
                return;
            }
            setSessionDetailsModal(true);
            return;
        }
        setActiveButton(Category?.toLowerCase()?.replace(/\s/g, '')); // Set the active button
        // if (Category == 'Register Now') {
        //     setPage('register');
        //     setModalBox(true);
        // }
    }

    const handleSummit = () => {
        if (!signupData.UPSCRollNo || !signupData.InterviewDate) {
            alert.error("Please fill all the fields")
            return
        }
        if (!signupData.Daf1 || !signupData.Daf2) {
            alert.show("Please upload all the files", {
                position: 'top center',
                timeout: 2000,
            })
            return
        }
        axios.post(`${BASE_URL}/igp/register`, { ...signupData })
            .then(response => {
                setModalBox(false);
                console.log('Registration successful:', response.data);
                // setSignupData(initialSignupData);
            })
            .catch(error => {
                console.error('Error during registration:', error);
                // Handle error (e.g., show an error message)
            })

    }

    const selectedFileHandler = async (fileType, file) => {
        try {
            const formData = new FormData();
            if (fileType === 'Daf1') {
                setFileUploading1(true);
                formData.append('uploadedFile', file, file.name);
            } else if (fileType === 'Daf2') {
                setFileUploading2(true)
                formData.append('uploadedFile', file, file.name);
            }
            const response = await axios.post(BASE_URL + '/uploadFile', formData);
            setSignupData({ ...signupData, [fileType]: response.data.imagePath });
        } catch (error) {
            console.log(error);
            alert.error(error.response.data.message)

        } finally {
            fileRef1.current.value = null;
            fileRef2.current.value = null;
            setTimeout(() => {
                setFileUploading1(false);
                setFileUploading2(false);
            }, 1000);

        }

    }
    const handleDashboardClick = () => {
        if (!authtoken) {
            alert.error("Please login first");
            setTimeout(() => {
                navigate('/login');
            }, 1000);
            return;
        }
        if (!isIGPRegistered) {
            setModalBox(true);
        } else {
            navigate('/StudentDashboard');
        }
    }


    // payement functionality
    const verifyIGPPayment = async (razorpay_order_id, razorpay_payment_id, razorpay_signature) => {
        const response = await axios.post(BASE_URL + '/paymentVarification', { razorpay_order_id, razorpay_payment_id, razorpay_signature });
        return response.data.success

    }
    const saveOrderDetails = async (amount, transactionid, status) => {
        try {
            let data = { email: authtoken, amount, transactionid, status, InterviewDate: sessionDetails.InterviewDate, InterviewTime: sessionDetails.InterviewTime, Location: sessionDetails.Location }
            const response = await axios.post(`${BASE_URL}/igp/saveSessionDetails`, data);
            console.log(response);
            if (response.data.statusCode == 200) {
                navigate("/paymentsuccess-igp", {
                    state: {
                        transactionId: response?.data?.data[0]?.TransactionID,
                        productTitle: "Interview Guidance Programme",
                    }
                })
            }
        } catch (error) {
            console.log(error)

        }
    }


    const handleIGPPayment = async (amount) => {
        const response = await axios.post(BASE_URL + '/checkout', { amount: 100 * Number(amount) || Number(100) });
        var options = {
            key: 'rzp_live_MiLEU5w3lLxTXm', // Enter the Key ID generated from the Dashboard
            amount: response.data.order.amount, // Amount is in currency subunits. Default currency is INR. Hence, 50000 refers to 50000 paise
            currency: "INR",
            name: "Insight Edutech Pvt...",
            description: "Test Transaction",
            image: logo1,
            order_id: response.data.order.id, //This is a sample Order ID. Pass the `id` obtained in the response of Step 1
            // callback_url: BASE_URL + '/paymentVarification',
            handler: (res) => {

                const isVerified = verifyIGPPayment(res.razorpay_order_id, res.razorpay_payment_id, res.razorpay_signature);


                if (isVerified) {
                    setTimeout(() => {
                        saveOrderDetails(amount, res.razorpay_payment_id, "Success");
                    }, 1000)

                } else {
                    swal("Invalid Payment Signature!", "Please Try Again", { icon: "error" })
                }

            },
            prefill: {
                name: userData?.FirstName,
                email: userData?.EmailId,
                contact: userData?.MobileNo,
            },
            notes: {
                address: "Razorpay Corporate Office"
            },
            theme: {
                color: "#005bf2"
            }
        };
        const rzpay = new window.Razorpay(options);
        rzpay.open();
    }


    const saveSessionDetails = async () => {
        try {
            if (!sessionDetails.InterviewDate || !sessionDetails.InterviewTime || !sessionDetails.Location) {
                alert.error("Please fill all fields")
                return;
            }
            const response = await axios.post(BASE_URL + '/igp/saveSessionDetails', sessionDetails);
            alert.success(response.data.message);
            setSessionDetailsModal(false);
            setSessionDetails(initialSessionDetails)
            setTimeout(() => {
                handleIGPPayment(1);
            }, 800)

        } catch (error) {
            console.log(error.message);
        }
    }

    return (
        <>
            <div className='CurrentAffairs-background '>
                <div className='current-main-box '>
                    <h1>Interview Guidance Programme »»</h1>
                    <div className='buttontab-background'>
                        <div className=''>
                            <div className=" d-flex justify-content-start align-items-start flex-wrap gap-2">
                                <button className={`btn btn-lg custom_igp_button `} type="button" onClick={handleDashboardClick}>
                                    {!isIGPRegistered ? "Register Now" : "Dashboard"}
                                </button>
                                {categories.map((obj, index) => (
                                    <button
                                         disabled={!isNextSlotBookingEnabled && obj.Category=='Book Your Slot'}
                                        key={index}
                                        className={`btn btn-lg  custom_igp_button`}
                                        onClick={() => handleClick(obj.Category)}
                                        type="button">{obj.Category}</button>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <section className="">
                {activeButton == 'homepage' && <HomePageText />}
                {activeButton == 'downloads' && <IDPDownloads />}
                {activeButton == 'igpclasses' && <IGPClasses />}
            </section>

            <Modal className="" show={modalBox} onHide={setModalBox} dialogClassName="igp_signup-modal" backdrop="static"
                keyboard={false} style={{ zIndex: "9999" }}>
                <Modal.Header className="position-relative justify-content-center py-2" style={{ backgroundImage: 'linear-gradient(to right, #9b0000, #6d0761)' }}>
                    <Modal.Title className="w-100 text-center text-white m-0 fw-bold " style={{ letterSpacing: "3px" }}>REGISTER FOR I.G.P</Modal.Title>
                    <Button variant="" onClick={() => setModalBox(false)} style={{ background: 'none', border: 'none', position: 'absolute', top: '0.3rem', right: '1rem' }}>
                        <IoMdClose size={32} color="white" />
                    </Button>
                </Modal.Header>


                <Modal.Body className='bg-light'>
                    <div className="container-fluid">

                        <div className="">


                            {/* <div className='d-md-flex justify-content-center align-items-center '>
                                        <div className="mb-3 col-md-6 px-2">
                                            <label htmlFor="fullName" className="form-label fw-semibold">Full Name</label>
                                            <input
                                                style={{ textDecoration: "capitalize" }}
                                                type="text"
                                                className="form-control fullName"
                                                id="fullName"
                                                placeholder='Full Name'
                                                aria-describedby="emailHelp"
                                                value={signupData.Name}
                                                onChange={(e) => setSignupData({ ...signupData, Name: e.target.value })}
                                            />
                                        </div>
                                        <div className="mb-3 col-md-6 px-2">
                                            <label htmlFor="email" className="form-label fw-semibold">Date of birth</label>
                                            <input
                                                type="date"
                                                className="form-control"
                                                id="email"
                                                placeholder='Your Email-ID'
                                                value={signupData.DOB}
                                                onChange={(e) => setSignupData({ ...signupData, DOB: e.target.value })}
                                            />
                                        </div>


                                    </div> */}

                            {/* <div className='d-md-flex justify-content-center align-items-center'>
                                        <div className="mb-3 col-md-6 px-2 ">
                                            <label htmlFor="email" className="form-label fw-semibold">Email ID</label>
                                            <input
                                                type="email"
                                                className="form-control"
                                                id="email"
                                                placeholder='Your Email-ID'
                                                value={signupData.EmailId}
                                                onChange={(e) => setSignupData({ ...signupData, EmailId: e.target.value })}
                                            
                                            />
                                        </div>
                                        <div className="mb-3 col-md-6 px-2">
                                            <label htmlFor="phoneNo" className="form-label fw-semibold">Phone No</label>
                                            <input
                                                type="number"
                                                className="form-control"
                                                id="phoneNo"
                                                placeholder='Mobile No'
                                                value={signupData.MobileNo}
                                                onChange={(e) => setSignupData({ ...signupData, MobileNo: e.target.value })}
                                          
                                            />
                                        </div>
                                    </div> */}
                            <div className='d-md-flex justify-content-center align-items-center'>
                                <div className="mb-3 col-md-6 px-2">
                                    <label htmlFor="phoneNo" className="form-label fw-semibold">UPSC Roll No.</label>
                                    <input
                                        type="number"
                                        className="form-control"
                                        id="phoneNo"
                                        placeholder='UPSC Roll No.'
                                        value={signupData.UPSCRollNo}
                                        onChange={(e) => setSignupData({ ...signupData, UPSCRollNo: e.target.value })}
                                    /* value={contact} */
                                    /* onChange={(e) => setContact(e.target.value)} */
                                    />
                                </div>
                                <div className="mb-3 col-md-6 px-2">
                                    <label htmlFor="email" className="form-label fw-semibold">Date of Interview</label>
                                    <input
                                        type="date"
                                        className="form-control"
                                        id="email"
                                        placeholder=''
                                        value={signupData.InterviewDate}
                                        onChange={(e) => setSignupData({ ...signupData, InterviewDate: e.target.value })}
                                    /* value={email} */
                                    /* onChange={(e) => setEmail(e.target.value.toLowerCase())} */
                                    />
                                </div>

                                {/* <div className="mb-3 col-md-6 px-2">
                                    <label htmlFor="password" className="form-label">Password</label>
                                    <input
                                        type="password"
                                        className="form-control"
                                        id="password"
                                        placeholder='Password'
                                   value={password} 
                                   onChange={(e) => setPassword(e.target.value)}
                                    />
                                </div> */}
                            </div>
                            <div className='d-md-flex justify-content-center align-items-center'>
                                <div className="mb-3 col-md-6 px-2">
                                    <label htmlFor='file1' className="form-label fw-semibold d-block"><FaUserCheck className='me-2' />DAF1</label>
                                    <label htmlFor="file1" style={{ backgroundColor: "#f0f0f0", padding: "10px", borderRadius: "6px", cursor: "pointer" }} className="custom-input w-75 "> <IoCloudUpload className='upload-icon1 me-1' size={23} />Upload File</label>
                                    <input ref={fileRef1} id="file1" style={{ display: "none" }} type="file" accept=".pdf" onChange={(event) => selectedFileHandler('Daf1', event.target.files[0])} />
                                    {fileUploading1 ? <Spinner className='' variant="info" /> : (signupData.Daf1) && <BsCheck style={{ cursor: "pointer" }} className='ms-2 bg-gray' color='green' size={40} />}
                                </div>
                                <div className="mb-3 col-md-6 px-2">
                                    <label htmlFor='file2' className="form-label fw-semibold d-block"><FaUserCheck className='me-2' />DAF2</label>
                                    <label for="file2" style={{ backgroundColor: "#f0f0f0", padding: "10px", borderRadius: "6px", cursor: "pointer" }} className="custom-input w-75"> <IoCloudUpload className='upload-icon1 me-1' size={23} />Upload File</label>
                                    <input ref={fileRef2} id="file2" style={{ display: "none" }} accept=".pdf" type="file" onChange={(event) => selectedFileHandler('Daf2', event.target.files[0])} />
                                    {fileUploading2 ? <Spinner className='' variant="info" /> : (signupData.Daf2) && <BsCheck style={{ cursor: "pointer" }} className='ms-2 bg-gray' color='green' size={40} />}
                                </div>

                            </div>
                            {/* <div className='d-md-flex justify-content-center align-items-center'>
                                        <div className="mb-3 col-md-6 px-2">
                                            <label htmlFor="password" className="form-label fw-semibold d-block">Password</label>
                                            <input
                                                type="password"
                                                className="form-control"
                                                id="password"
                                                placeholder='Password'
                                                value={signupData.Password}
                                                onChange={(e) => setSignupData({ ...signupData, Password: e.target.value })}
                                           
                                            />
                                        </div>
                                        <div className="mb-3 col-md-6 px-2">

                                        </div>
                                    </div> */}
                            <div className="d-flex flex-column justify-content-center align-items-center">
                                <div className="w-100" style={{ maxWidth: "500px" }}>
                                    <button
                                        className="btn btn-primary login-btn w-100 py-2 border-0"
                                        type="button"
                                        onClick={handleSummit}
                                    >
                                        REGISTER
                                    </button>
                                </div>
                            </div>
                        </div>




                        {/* <div className="d-flex justify-content-center align-items-center py-3">
                                    <div className="w-100" style={{ maxWidth: "500px" }}>
                                        <div className="mb-3 px-2">
                                            <label htmlFor="email" className="form-label fw-semibold">Email ID</label>
                                            <input type="email" className="form-control" id="email" placeholder="Your Email-ID" value={loginData.EmailId} onChange={(e) => setLoginData({ ...loginData, EmailId: e.target.value })} />
                                        </div>
                                        <div className="mb-3 px-2">
                                            <label htmlFor="password" className="form-label fw-semibold">Password</label>
                                            <input type="password" className="form-control" id="password" placeholder="Password" value={loginData.Password} onChange={(e) => setLoginData({ ...loginData, Password: e.target.value })} />
                                        </div>
                                        <div className="d-flex justify-content-center align-items-center mt-5 px-2">
                                            <div className="w-100" style={{ maxWidth: "500px" }}>
                                                <button className="btn btn-primary login-btn w-100 py-2 border-0" onClick={handleSummit}>Login</button>
                                            </div>
                                        </div>
                                    </div>
                                </div> */}




                    </div>
                </Modal.Body>
                <Modal.Footer className='bg-light d-flex justify-content-center align-items-center p-2 bg-gray m-1'>

                </Modal.Footer>

            </Modal>
            <Modal className="" show={sessionDetailsModal} onHide={setSessionDetailsModal} dialogClassName="" backdrop="static"
                keyboard={false} style={{ zIndex: "9999" }}>
                <Modal.Header className="position-relative justify-content-center py-2" style={{ backgroundImage: 'linear-gradient(to right, #9b0000, #6d0761)' }}>
                    <Modal.Title className="w-100 text-center text-white m-0 fw-bold " style={{ letterSpacing: "2px" }}>INTERVIEW DETAILS</Modal.Title>
                    <Button variant="" onClick={() => setSessionDetailsModal(false)} style={{ background: 'none', border: 'none', position: 'absolute', top: '0.3rem', right: '1rem' }}>
                        <IoMdClose size={32} color="white" />
                    </Button>
                </Modal.Header>


                <Modal.Body className='bg-light'>
                    <div className="container-fluid">
                        <div className="">
                            <div className=''>
                                <div className="mb-3  px-2">
                                    <label htmlFor="phoneNo" className="form-label fw-semibold">Mock Interview Date</label>
                                    <input
                                        type="date"
                                        className="form-control"
                                        id="phoneNo"
                                        placeholder='UPSC Roll No.'
                                        value={sessionDetails.InterviewDate}
                                        onChange={(e) => setSessionDetails({ ...sessionDetails, InterviewDate: e.target.value })}
                                    /* value={contact} */
                                    /* onChange={(e) => setContact(e.target.value)} */
                                    />
                                </div>
                                <div className="mb-3 px-2">
                                    <label htmlFor="DATAOFINTERVIEW" className="form-label fw-semibold">Mock Interview Time</label>
                                    <input
                                        type="time"
                                        className="form-control"
                                        id="DATAOFINTERVIEW"
                                        placeholder=''
                                        value={sessionDetails.InterviewTime}
                                        onChange={(e) => setSessionDetails({ ...sessionDetails, InterviewTime: e.target.value })}
                                    /* value={email} */
                                    /* onChange={(e) => setEmail(e.target.value.toLowerCase())} */
                                    />
                                </div>
                                <div className="mb-3 px-2">
                                    <label htmlFor="interviewLOCATION" className="form-label fw-semibold">Mock Interview Location</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="interviewLOCATION"
                                        placeholder='Please enter interview location'
                                        value={sessionDetails.Location}
                                        onChange={(e) => setSessionDetails({ ...sessionDetails, Location: e.target.value })}
                                    /* value={email} */
                                    /* onChange={(e) => setEmail(e.target.value.toLowerCase())} */
                                    />
                                </div>


                            </div>


                            <div className="d-flex flex-column justify-content-center align-items-center">
                                <div className="w-100" style={{ maxWidth: "500px" }}>
                                    <button
                                        className="btn btn-primary login-btn w-100 py-2 border-0"
                                        type="button"
                                        onClick={() => { handleIGPPayment(1); setSessionDetailsModal(false) }}
                                    >
                                        MAKE PAYMENT
                                    </button>
                                </div>
                            </div>
                        </div>




                        {/* <div className="d-flex justify-content-center align-items-center py-3">
                                    <div className="w-100" style={{ maxWidth: "500px" }}>
                                        <div className="mb-3 px-2">
                                            <label htmlFor="email" className="form-label fw-semibold">Email ID</label>
                                            <input type="email" className="form-control" id="email" placeholder="Your Email-ID" value={loginData.EmailId} onChange={(e) => setLoginData({ ...loginData, EmailId: e.target.value })} />
                                        </div>
                                        <div className="mb-3 px-2">
                                            <label htmlFor="password" className="form-label fw-semibold">Password</label>
                                            <input type="password" className="form-control" id="password" placeholder="Password" value={loginData.Password} onChange={(e) => setLoginData({ ...loginData, Password: e.target.value })} />
                                        </div>
                                        <div className="d-flex justify-content-center align-items-center mt-5 px-2">
                                            <div className="w-100" style={{ maxWidth: "500px" }}>
                                                <button className="btn btn-primary login-btn w-100 py-2 border-0" onClick={handleSummit}>Login</button>
                                            </div>
                                        </div>
                                    </div>
                                </div> */}




                    </div>
                </Modal.Body>
                <Modal.Footer className='bg-light d-flex justify-content-center align-items-center p-2 bg-gray m-1'>

                </Modal.Footer>

            </Modal>


        </>
    );
}

export default InterviewGuidance;
